module.exports = __webpack_public_path__ + "static/img/re.17909e37.svg";